import { useState, useCallback } from 'react';

export const useBooleanState = defaultValue => {
	const [value, setValue] = useState(defaultValue);
	const toggleValue = useCallback(() => setValue(!value), [value]);

	return [value, toggleValue];
};

